import configStore from '../../../redux/configStore';
import middlewares from '../../../redux/middlewares';
import stateSaver from '../../../utils/stateSaver';
import reducers from './reducers';

export const createServerStore = (initialState = {}) => configStore(
  reducers,
  middlewares,
  initialState,
);

const isClient = typeof window !== 'undefined';

const serverState = isClient && window.__REDUX_STATE__;
if (serverState) delete window.__REDUX_STATE__;

const store = isClient
  ? configStore(reducers, middlewares, serverState || stateSaver.getInitialState())
  : null;

if (isClient && !serverState) stateSaver.clear();
if (isClient) stateSaver.listen(store);

export default store;
